import { Result } from "antd";
import { observer } from "mobx-react-lite";


const NotFound = observer(() => {
    return <Result status="404" title="Page Not found"/>
})

export default NotFound